var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgJcb = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H6.4C7.856 20 9.6 18.3573 9.6 17.0667V0H3.2C1.744 0 0 1.64267 0 4.4V20Z",
    fill: "#047AB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.632 13.8719C2.40333 13.8721 1.18072 13.7142 0 13.4026V11.7893C0.916242 12.3086 1.96355 12.6017 3.04 12.6399C4.272 12.6399 4.96 11.8479 4.96 10.7626V6.33325H8V10.7626C8 12.4933 7.008 13.8719 3.632 13.8719Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 20H17.5999C19.0559 20 20.7999 18.3573 20.7999 17.0667V0H14.4C12.944 0 11.2 1.64267 11.2 4.4V20Z",
    fill: "#D42D06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 7.35995C12.128 6.53862 13.728 6.02528 16.32 6.14262C17.728 6.20128 19.2 6.58262 19.2 6.58262V8.21062C18.358 7.74384 17.4117 7.45802 16.432 7.37462C14.464 7.21328 13.264 8.22528 13.264 9.99995C13.264 11.7746 14.464 12.7866 16.432 12.64C17.4123 12.5491 18.358 12.2585 19.2 11.7893V13.4026C19.2 13.4026 17.728 13.7986 16.32 13.8573C13.728 13.9746 12.128 13.4613 11.2 12.64V7.35995Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3999 20H28.7999C30.2559 20 31.9999 18.3573 31.9999 17.0667V0H25.5999C24.1439 0 22.3999 1.64267 22.3999 4.4V20Z",
    fill: "#67B637"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 11.7599C30.3999 12.9333 29.4079 13.6666 28.0799 13.6666H22.3999V6.33325H27.5679L27.9359 6.34792C29.1039 6.40658 29.9679 7.03725 29.9679 8.12258C29.9679 8.97325 29.3759 9.70658 28.3039 9.88259V9.92659C29.4879 9.99992 30.3999 10.6893 30.3999 11.7599ZM26.3199 7.49192C26.251 7.48248 26.1815 7.47758 26.1119 7.47725H24.1919V9.32525H26.3199C26.7199 9.23725 27.0559 8.89992 27.0559 8.40125C27.0559 7.90258 26.7199 7.56525 26.3199 7.49192ZM26.5599 10.4839C26.4753 10.4717 26.3895 10.4668 26.3039 10.4693H24.1919V12.4786H26.3039L26.5599 12.4493C26.9599 12.3613 27.2959 11.9799 27.2959 11.4666C27.2959 10.9533 26.9759 10.5866 26.5599 10.4839Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJcb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/JCB.c419dd2158bebbac45e7de5c70672fc4.svg";